export const ModelStatus = {
  Normal: 0,
  Training: 1,
  Updating: 2,
  Predicting: 3,
  PredictEvaluating: 4,
  ErrorTrain: -1,
  ErrorUpdate: -2,
  ErrorPredict: -3,
  ErrorPredictEvaluate: -4
}

export const InformationImportance = {
  High: 10,
  Medium: 20,
  Low: 30
}

export const OverUseType = {
  Nothing: 0,
  WillOver: 1,
  DidOver: 2
}



// WEBPACK FOOTER //
// ./src/defines/enum.js